// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `ion-col {
  text-align: center;
}

.footer-buttons {
  display: flex;
  justify-content: center;
  gap: 25%;
  max-width: 600px;
  margin: 0 auto;
}

ion-toolbar {
  --padding-top: 0;
  --padding-bottom: 0;
  --padding-start: 20px;
  --padding-end: 20px;
}

ion-grid {
  --ion-grid-padding: 0;
}

ion-col {
  --ion-grid-column-padding: 0;
}

.ion-badge-footer-version {
  position: absolute;
  right: 5px;
  top: 17px;
}

@media (max-width: 450px) {
  .footer-buttons {
    gap: 15%;
  }
  .ion-badge-footer-version {
    font-size: 0.75rem;
    top: 18px;
  }
}
@media (max-width: 300px) {
  .footer-buttons {
    gap: 5%;
  }
  .ion-badge-footer-version {
    font-size: 0.65rem;
    right: 2px;
    top: 19px;
  }
}
@media (max-width: 220px) {
  .footer-buttons {
    gap: 0%;
  }
  .ion-badge-footer-version {
    font-size: 0.5rem;
    right: 1px;
    top: 20px;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/components/footer/footer.component.scss","webpack://./../../../../../../Program%20Files%20(x86)/Jenkins/workspace/Quadra%20Service%20Call%20Pipeline/QuadraServiceCall/Client/src/app/components/footer/footer.component.scss"],"names":[],"mappings":"AAAA;EACE,kBAAA;ACCF;;ADEA;EACE,aAAA;EACA,uBAAA;EACA,QAAA;EACA,gBAAA;EACA,cAAA;ACCF;;ADEA;EACE,gBAAA;EACA,mBAAA;EACA,qBAAA;EACA,mBAAA;ACCF;;ADEA;EACE,qBAAA;ACCF;;ADEA;EACE,4BAAA;ACCF;;ADEA;EACE,kBAAA;EACA,UAAA;EACA,SAAA;ACCF;;ADGA;EACE;IACE,QAAA;ECAF;EDGA;IACE,kBAAA;IACA,SAAA;ECDF;AACF;ADIA;EACE;IACE,OAAA;ECFF;EDKA;IACE,kBAAA;IACA,UAAA;IACA,SAAA;ECHF;AACF;ADMA;EACE;IACE,OAAA;ECJF;EDOA;IACE,iBAAA;IACA,UAAA;IACA,SAAA;ECLF;AACF","sourcesContent":["ion-col {\r\n  text-align: center;\r\n}\r\n\r\n.footer-buttons {\r\n  display: flex;\r\n  justify-content: center;\r\n  gap: 25%;\r\n  max-width: 600px;\r\n  margin: 0 auto;\r\n}\r\n\r\nion-toolbar {\r\n  --padding-top: 0;\r\n  --padding-bottom: 0;\r\n  --padding-start: 20px;\r\n  --padding-end: 20px;\r\n}\r\n\r\nion-grid {\r\n  --ion-grid-padding: 0;\r\n}\r\n\r\nion-col {\r\n  --ion-grid-column-padding: 0;\r\n}\r\n\r\n.ion-badge-footer-version {\r\n  position: absolute;\r\n  right: 5px;\r\n  top: 17px;\r\n}\r\n\r\n// Media queries for smaller screens\r\n@media (max-width: 450px) {\r\n  .footer-buttons {\r\n    gap: 15%;\r\n  }\r\n\r\n  .ion-badge-footer-version {\r\n    font-size: 0.75rem;\r\n    top: 18px;\r\n  }\r\n}\r\n\r\n@media (max-width: 300px) {\r\n  .footer-buttons {\r\n    gap: 5%;\r\n  }\r\n\r\n  .ion-badge-footer-version {\r\n    font-size: 0.65rem;\r\n    right: 2px;\r\n    top: 19px;\r\n  }\r\n}\r\n\r\n@media (max-width: 220px) {\r\n  .footer-buttons {\r\n    gap: 0%;\r\n  }\r\n\r\n  .ion-badge-footer-version {\r\n    font-size: 0.5rem;\r\n    right: 1px;\r\n    top: 20px;\r\n  }\r\n}\r\n\r\n","ion-col {\n  text-align: center;\n}\n\n.footer-buttons {\n  display: flex;\n  justify-content: center;\n  gap: 25%;\n  max-width: 600px;\n  margin: 0 auto;\n}\n\nion-toolbar {\n  --padding-top: 0;\n  --padding-bottom: 0;\n  --padding-start: 20px;\n  --padding-end: 20px;\n}\n\nion-grid {\n  --ion-grid-padding: 0;\n}\n\nion-col {\n  --ion-grid-column-padding: 0;\n}\n\n.ion-badge-footer-version {\n  position: absolute;\n  right: 5px;\n  top: 17px;\n}\n\n@media (max-width: 450px) {\n  .footer-buttons {\n    gap: 15%;\n  }\n  .ion-badge-footer-version {\n    font-size: 0.75rem;\n    top: 18px;\n  }\n}\n@media (max-width: 300px) {\n  .footer-buttons {\n    gap: 5%;\n  }\n  .ion-badge-footer-version {\n    font-size: 0.65rem;\n    right: 2px;\n    top: 19px;\n  }\n}\n@media (max-width: 220px) {\n  .footer-buttons {\n    gap: 0%;\n  }\n  .ion-badge-footer-version {\n    font-size: 0.5rem;\n    right: 1px;\n    top: 20px;\n  }\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
